<div class="logout-page kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1" id="kt_login">
		<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
			<!--begin::Aside-->
			<div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside" 
				[ngStyle]="{'background-image': getPageBackground()}">
				<div class="kt-grid__item">
					<a href="javascript:;" class="kt-login__logo">
						<img [src]="headerLogo" alt="">
					</a>
				</div>
				<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
					<div class="kt-grid__item kt-grid__item--middle">
						<h3 class="kt-login__title">{{ 'AUTH.GENERAL.LOGOUT_MESSAGE' | translate }}</h3>
					</div>
				</div>
				<div class="kt-grid__item">
					<div class="kt-login__info">
						<div class="kt-login__copyright">
							© {{today|date:'yyyy'}} PricewaterhouseCoopers International
						</div>						
					</div>
				</div>
			</div>
			<!--begin::Aside-->
	
			<!--begin::Content-->
			<div class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
				<!--begin::Body-->
				<div class="kt-login__body">
					<!--begin::Signin-->
					<div class="kt-login__form">
						<div class="kt-login__title">
							<h3>GRIP</h3>
						</div>
			
						<kt-auth-notice></kt-auth-notice>
			
						<!--begin::Form-->
						<form class="kt-form">	
							<!--begin::Action-->							
							<div class="kt-login__actions" style="text-align: center">
								<div class="redirect-button">
										<button (click)="login()" id="kt_login_signin_submit" class="btn btn-default btn-elevate kt-login__btn-primary">
												{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}
											</button>
								</div>								
							</div>
							<!--end::Action-->
						</form>
						<!--end::Form-->

						<!--begin::Divider-->
						<div class="kt-login__divider">
							<div class="kt-divider">
								<span></span>
								<span>{{ 'AUTH.GENERAL.LANGUAJE' | translate }}</span>
								<span></span>
							</div>
						</div>
						<!--end::Divider-->

						<!--begin::Options-->
						<div style="width: 26px;justify-content: center !important;">
						<kt-language-selector></kt-language-selector>
						</div>
						<!--end::Options-->
					</div>
					<!--end::Signin-->
				</div>
				<!--end::Body-->
			</div>
			<!--end::Content-->
		</div>
</div>


